import React, { forwardRef, useEffect, useState } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import dateFormat from 'dateformat';
import dayjs from "dayjs";

const PrintPdf = forwardRef((props, ref) => {
    const [item, setItem] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const sID = localStorage.getItem('sID');
        fetch('https://dirasa.in/api/getFormInfo.php?sID=' + sID)
            .then(res => res.json())
            .then(json => {
                setItem(json.data);
                setIsLoaded(true);
            })
            .catch(err => console.error(err));
    }, []);

    if (!isLoaded || !item) {
        return <div ref={ref} style={{ padding: "50px" }}>Loading...</div>;
    }

    return (
        <div ref={ref} style={{ padding: "40px", width: "794px" , fontFamily: "Calibri, Arial, Helvetica, sans-serif",
    color: "#000"}}>
            <Container style={{ border: "2px solid #000", padding: "10px" }}>
                <Row>
                    <Col>

                        {/* HEADER */}
                        <div className="text-center" >
                            <img
                                src={process.env.PUBLIC_URL + '/img/header.jpeg'}
                                alt="Header"
                                style={{ width: "220px" }}
                            />
                        </div>
                         <div className="text-center" style={{ color: "red", fontFamily: "'Clibri'", fontSize: "14px" }}>
                            Head Office: 420 More (NH-34), Malda, 732101, W.B
                        </div>
                        <div className="text-center" style={{ color: "red", fontFamily: "'Clibri'", fontSize: "14px" }}>
                            Contact: 9733202035 / 8697131519
                        
                            Email: support@dirasa.in Website: www.dirasa.in
                        </div>
                         <div className="text-center" style={{ backgroundColor: "red", padding: "2px",  marginTop: "10px" }}>
                            <span style={{ backgroundColor: "red", padding: "2px", borderRadius: "10px", color: "#fff", fontWeight: "700", fontSize: "20px" }}>
                                ADMIT CARD
                            </span>
                        </div>

                        {/* MAIN TABLE */}
                        <Table
                            bordered
                            style={{
                                fontSize: "14px",
                                width: "100%",
                                borderCollapse: "collapse",
                                lineHeight: ".6"   
                            }}
                        >
                            <tbody>

                                {/* FORM NO + PHOTO + SIGNATURE */}
                                <tr>
                                    <td style={{ fontWeight: "600", width: "220px" }}>FORM NO</td>
                                    <td colSpan={3}>{item.form_id}</td>

                                    <td rowSpan={6} style={{
                                                        width: "200px",
                                                        padding: "6px",
                                                        textAlign: "center",
                                                        verticalAlign: "top"
                                                    }}>
                                            {/* PHOTO */}
                                        <div
                                            style={{
                                                width: "120px",
                                                height: "140px",
                                                border: "1px solid #000",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto"   // ✅ KEY
                                            }}
                                        >

                                            {item.student_photo_url ? (
                                                <img
                                                    src={item.student_photo_url}
                                                    alt="Student"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            ) : (
                                                <span>PHOTO</span>
                                            )}
                                        </div>

                                        {/* SIGNATURE */}
                                        <div
                                            style={{
                                                marginTop: "6px",
                                                width: "120px",
                                                height: "36px",
                                                border: "1px solid #7a7a7a",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginLeft: "auto",   // ✅
                                                marginRight: "auto"   // ✅
                                            }}
                                        >

                                            {item.student_signature_url ? (
                                                <img
                                                    src={item.student_signature_url}
                                                    alt="Signature"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            ) : (
                                                <span>SIGNATURE</span>
                                            )}
                                        </div>

                                        
                                    </td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>NAME OF CANDIDATE</td>
                                    <td colSpan={3}>{item.name?.toUpperCase()}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>GENDER</td>
                                    <td>{item.gender}</td>
                                    <td style={{ fontWeight: "600" }}>CATEGORY</td>
                                    <td>{item.category}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>DATE OF BIRTH</td>
                                    <td>
                                        {item.dob
                                            ? dayjs(item.dob).format("DD-MM-YYYY")
                                            : ""}
                                        </td>
                                    <td style={{ fontWeight: "600" }}>RELIGION</td>
                                    <td>{item.religion}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>GUARDIAN NAME</td>
                                    <td colSpan={3}>{item.guardian_name?.toUpperCase()}</td>
                                </tr>

                                {/* ✅ GUARDIAN OCCUPATION (NEW) */}
                                <tr>
                                    <td style={{ fontWeight: "600" }}>GUARDIAN OCCUPATION</td>
                                    <td colSpan={3}>{item.guardian_occupation?.toUpperCase()}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>ADDRESS</td>
                                    <td colSpan={4}>{item.address?.toUpperCase()}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>COURSE</td>
                                    <td colSpan={4} >{item.course}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>STUDENT CONTACT NO</td>
                                    <td>{item.contact}</td>
                                    <td style={{ fontWeight: "600" }} colSpan={2}>GUARDIAN CONTACT</td>
                                    <td>{item.guardian_contact}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: "600" }}>EXAM CENTER</td>
                                    <td colSpan={4} style={{ lineHeight: "1.3" }}>
                                        {item.exam_center?.toUpperCase()}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5} style={{ textAlign: "center", fontSize: "13px" }} >Invigilators must verify the candidate’s photograph and signature at the examination center</td>
                                </tr>            
                            </tbody>
                        </Table>

                        {/* DECLARATION */}
                        <div style={{  fontSize: "13px" }}>
                            I hereby declare that all the information provided above is correct.
                        </div>

                        {/* SIGNATURE FOOTER */}
                        <div style={{ marginTop: "50px" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end"
                                }}
                            >
                                {/* STUDENT SIGNATURE */}
                                <div style={{ width: "20%", textAlign: "left" }}>
                                    <div
                                        style={{
                                            borderBottom: "1px dashed #000",
                                            height: "18px",
                                            marginBottom: "6px"
                                        }}
                                    ></div>
                                    <div>Student Signature</div>
                                </div>

                                {/* GUARDIAN SIGNATURE */}
                                <div style={{ width: "20%", textAlign: "right" }}>
                                    <div
                                        style={{
                                            borderBottom: "1px dashed #000",
                                            height: "18px",
                                            marginBottom: "6px"
                                        }}
                                    ></div>
                                    <div>Guardian Signature</div>
                                </div>
                            </div>
                        </div>


                         <div style={{ marginTop: "10px", paddingLeft: "35px", fontSize: "13px", color: "#000", lineHeight: "1.6" }}>
                                <div
                                    style={{
                                        marginTop: "20px",
                                        textAlign: "center",
                                        color: "red",
                                        fontWeight: "700"
                                    }}
                                    >
                                    **<span style={{ textDecoration: "underline" }}>Important Instructions</span>
                                    </div>

                                <div style={{ marginBottom: "10px" }}>
                                    ➤ <strong>পরীক্ষার দিন:</strong> পরীক্ষার্থীদের অবশ্যই এই আবেদনপত্রটি (Application Form)
                                    পরীক্ষাকেন্দ্রে সঙ্গে করে নিয়ে আসতে হবে।
                                </div>            
                                <div style={{ marginBottom: "10px" }}>
                                    ➤ <strong>পরীক্ষার ফলাফল:</strong> <strong>২৬শে ফেব্রুয়ারি, ২০২৬</strong>, বিকাল ৪ ঘটিকায় পরীক্ষার্থীর
                                    WhatsApp নম্বরে জানানো হবে এবং এই সাইটে
                                    <strong> www.dirasa.in </strong> প্রকাশিত হবে।
                                </div>

                                <div style={{ marginBottom: "10px" }}>
                                    ➤ <strong>Counselling:</strong> Admission Test- এর মেধা তালিকার ভিত্তিতে পরীক্ষার্থী অভিভাবক–অভিভাবিকাদের উপস্থিতিতে সাক্ষাৎকার
                                    (Interview) ও কাউন্সেলিং ভিত্তিতে ভর্তি নেওয়া শুরু হবে <strong>২৮শে ফেব্রুয়ারি, ২০২৬ থেকে</strong>।
                                </div>
                                <div style={{ marginBottom: "10px" }}>
                                    ➤  প্রত্যেক প্রার্থীকে পরীক্ষাকেন্দ্রে ₹৫০/- সঙ্গে নিয়ে উপস্থিত হতে হবে।
                                </div>
                                


                            


                            <div style={{ marginTop: "8px", textAlign: "center", color: "red", fontWeight: "700", textDecoration: "underline" }}>
                                Admission Test Syllabus
                            </div>

                            <div style={{ textAlign: "center", marginTop: "4px", fontWeight: "600" }}>
                                বিজ্ঞান বিভাগ
                            </div>

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "8px", gap: "10px", fontSize: "12px" }}>
                                <div style={{ background: "red", color: "#fff", padding: "6px 14px", borderRadius: "4px" }}>
                                    ইংরেজী – ২০
                                </div>
                                <div style={{ background: "red", color: "#fff", padding: "6px 14px", borderRadius: "4px" }}>
                                    গণিত – ২০
                                </div>
                                <div style={{ background: "red", color: "#fff", padding: "6px 14px", borderRadius: "4px" }}>
                                    জীবন বিজ্ঞান – ৩০
                                </div>
                                <div style={{ background: "red", color: "#fff", padding: "6px 14px", borderRadius: "4px" }}>
                                    ভৌত বিজ্ঞান – ৩০
                                </div>
                            </div>

                        </div>

                        {/* DATE */}
                        <div style={{ marginTop: "20px", fontSize: "12px" }}>
                            *DATE & TIME OF FORM SUBMISSION :
                            {` ${dateFormat(item.created_at, "dd-MM-yyyy HH:mm:ss")}`}
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    );
});

export default PrintPdf;
